import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Slide, { SlideProps } from "@mui/material/Slide";
import classes from "./ToastStyles.module.scss";
import erroricon from "../../Components/assets/Images/errorIcon.svg";
type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="left" />;
}

interface props {
  message: string;
}

export default function SnackBar({ message }: props) {
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message) {
      setOpen(true);
      setTransition(() => TransitionUp);
      setTimeout(() => {
        setOpen(false);
      }, 3000);
    }
  }, [message]);

  //console.log(message)
  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        TransitionComponent={transition}
        sx={{ marginTop: "60px" }}
      >
        <div
          className={`${classes.wrapper2} animate__animated animate__fadeInRight`}
        >
          <img src={erroricon} alt="" />
          <div className={classes.content}>
            <div className={classes.text1}>Failure</div>
            <div className={classes.text2}>{message}</div>
          </div>
        </div>
        {/* <div style={{ background: "#FF6161", borderRadius: "10px 0px 0px 10px", overflow:'hidden' }}>
          <div style={{ marginLeft: "30px" }}>
            <Alert
              icon={false}
              severity="success"
              sx={{
                width: { xs: "100%", sm: "max-content" },
                maxWidth:"500px",
                minHeight: "50px",
                fontSize: "14px",
                borderRadius: "0",
                display: "flex",
                alignItems: "center",
                background: "#FFE8E8",
                textWrap: "wrap",
                fontFamily: "inherit",
              }}
            >
              {message}
            </Alert>
          </div>
        </div> */}
      </Snackbar>
    </div>
  );
}
